(() => {
  const hoverPreview = window.matchMedia('(hover: hover) and (pointer: fine)');
  function showCardRole(card, role) {
    const preview = card.querySelector('[data-couple-preview]');
    const member = preview?.querySelector(`[data-couple-card-member="${role}"]`);
    if (!member) return;
    const request = (card.previewRequest || 0) + 1;
    card.previewRequest = request;
    const apply = () => {
      if (card.previewRequest !== request) return;
      preview.dataset.role = role;
      preview.querySelectorAll('[data-couple-card-member]').forEach(item => item.setAttribute('aria-hidden', String(item !== member)));
      card.querySelectorAll('[data-couple-card-role]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.coupleCardRole === role)));
      if (member.dataset.previewUrl) card.querySelectorAll('[data-card-product-link]').forEach(link => { link.href = member.dataset.previewUrl; });
      const price = card.querySelector('[data-card-price]');
      if (price && member.dataset.previewPrice) price.textContent = member.dataset.previewPrice;
    };
    const image = member.querySelector('img');
    if (!image || (image.complete && image.naturalWidth > 0)) apply();
    else image.addEventListener('load', apply, { once: true });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-couple-card-role]');
    if (!button) return;
    const card = button.closest('[data-couple-card]');
    if (!card) return;
    card.dataset.selectedRole = button.dataset.coupleCardRole;
    showCardRole(card, card.dataset.selectedRole);
  });
  document.addEventListener('pointerover', event => {
    if (!hoverPreview.matches || event.pointerType !== 'mouse') return;
    const media = event.target.closest('[data-couple-card] .product-card__media');
    if (!media || media.contains(event.relatedTarget)) return;
    const card = media.closest('[data-couple-card]');
    showCardRole(card, card.dataset.selectedRole === 'her' ? 'him' : 'her');
  });
  document.addEventListener('pointerout', event => {
    const media = event.target.closest('[data-couple-card] .product-card__media');
    if (!media || media.contains(event.relatedTarget)) return;
    const card = media.closest('[data-couple-card]');
    showCardRole(card, card.dataset.selectedRole || 'him');
  });
  class ApexCouple extends HTMLElement {
    connectedCallback() {
      this.members = [...this.querySelectorAll('[data-couple-member]')];
      this.onClick = event => {
        const choice = event.target.closest('[data-couple-view]');
        if (!choice) return;
        this.show(choice.dataset.coupleView, true);
        const active = this.members.find(member => !member.hidden);
        const panel = active && [...active.querySelectorAll('[data-offering-panel]')].find(item => !item.hidden);
        panel?.querySelector('[data-couple-view="' + this.view + '"]')?.focus({ preventScroll: true });
      };
      this.onReady = () => this.syncButtons();
      this.onHistory = () => this.show(new URLSearchParams(location.search).get('role') || this.dataset.defaultRole || 'him', false);
      this.addEventListener('click', this.onClick);
      this.addEventListener('apex:offering-ready', this.onReady);
      window.addEventListener('popstate', this.onHistory);
      this.onHistory();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('apex:offering-ready', this.onReady);
      window.removeEventListener('popstate', this.onHistory);
    }
    syncButtons() {
      this.querySelectorAll('[data-couple-view]').forEach(button => {
        const selected = button.dataset.coupleView === this.view;
        button.setAttribute('aria-pressed', String(selected));
        button.classList.toggle('is-active', selected);
      });
    }
    show(role, updateUrl) {
      this.view = role === 'her' ? 'her' : 'him';
      this.members.forEach(member => { member.hidden = member.dataset.coupleMember !== this.view; });
      this.syncButtons();
      const activeMember = this.members.find(member => !member.hidden);
      const activePanel = activeMember && [...activeMember.querySelectorAll('[data-offering-panel]')].find(panel => !panel.hidden);
      if (activePanel) activeMember.querySelector('apex-product-configurator')?.placeRatingBlocks?.(activePanel);
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('role', this.view);
        for (const key of ['variant', 'fit', 'family', 'color', 'side', 'ink']) url.searchParams.delete(key);
        history.pushState({ role: this.view }, '', url);
      }
    }
  }
  if (!customElements.get('apex-couple')) customElements.define('apex-couple', ApexCouple);
})();
